import React, { useState } from 'react';
import AIOnboardingEntry from './AIOnboardingEntry';
import AIOnboardingWizard from './AIOnboardingWizard';

const AIOnboarding = () => {
  const [stage, setStage] = useState('entry'); // 'entry' or 'wizard'
  const [selectedPath, setSelectedPath] = useState(null); // 'university', 'field', 'unsure'

  const handleSelectPath = (path) => {
    setSelectedPath(path);
    setStage('wizard');
  };

  const handleBackToEntry = () => {
    setStage('entry');
    setSelectedPath(null);
  };

  return (
    <div className="min-h-screen app-shell">
      {stage === 'entry' ? (
        <AIOnboardingEntry onSelectPath={handleSelectPath} />
      ) : (
        <AIOnboardingWizard
          path={selectedPath}
          onBackToEntry={handleBackToEntry}
        />
      )}
    </div>
  );
};

export default AIOnboarding;
